import "./instrument";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import NewContainerFlow from './containers/NewContainerFlow';
import MyApp from './containers/MyApp';
import MyAppOverview from './containers/MyAppOverview';
import MyAppDeployments from './containers/MyAppDeployments';
import MyAppLogs from './containers/MyAppLogs';
import MyAppSource from './containers/MyAppSource';
import MyAppDatabase from './containers/MyAppDatabase';
import MyAppMetrics from './containers/MyAppMetrics';
import MyAppSettings from './containers/MyAppSettings';
import MyAgents from './containers/MyAgents';
import CreateAgent from './containers/CreateAgent';
import RequireAgentSubscription from './components/RequireAgentSubscription';
import RedirectToMyApps from './components/RedirectToMyApps';
import StripeReturnPage from "./containers/StripeReturnPage";
import { Toaster } from 'react-hot-toast';
import './index.css';

async function bootstrap() {
  if (typeof globalThis.fetch !== 'function') {
    await import('cross-fetch/polyfill');
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          {/* The app list lives on the dashboard. Outside `App`, so nothing of
              this one loads on the way there. */}
          <Route index element={<RedirectToMyApps />} />
          <Route path="apps" element={<RedirectToMyApps />} />
          <Route path="/" element={<App />}>
            <Route path="new-container" element={<NewContainerFlow />} />
            <Route path="return" element={<StripeReturnPage />} />
            <Route path="apps/:appId/" element={<MyApp />}>
              <Route index element={<MyAppOverview />} />
              <Route path="deployments" element={<MyAppDeployments />} />
              <Route path="source" element={<MyAppSource />} />
              <Route path="logs" element={<MyAppLogs />} />
              <Route path="database" element={<MyAppDatabase />} />
              <Route path="metrics" element={<MyAppMetrics />} />
              <Route path="settings" element={<MyAppSettings />} />
            </Route>
            <Route path="agents/new" element={<RequireAgentSubscription><CreateAgent /></RequireAgentSubscription>} />
            <Route path="agents" element={<RequireAgentSubscription><MyAgents /></RequireAgentSubscription>} />
            <Route path="agents/:agentId/" element={<RequireAgentSubscription><MyAgents /></RequireAgentSubscription>} />
          </Route>        
        </Routes>
      </BrowserRouter>
      <Toaster />
    </React.StrictMode>
  );
}

void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
